import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Academy = () => {
  /*
  const programs = [
    {
      title: "Youth Development",
      description: "Specialized programs for young golfers aged 6-18, focusing on fundamentals, technique, and competitive skills.",
      imageUrl: "https://images.squarespace-cdn.com/content/v1/5bd9eaf070e802753aaeaf18/1672867343644-WZQZU6LY50BXDDCZJYI2/unsplash-image-aGlpdQ2Yolk.jpg",
      features: ["Age-appropriate training", "School integration", "Tournament preparation", "Scholarship opportunities"]
    },
    {
      title: "Women in Golf",
      description: "Dedicated programs to increase female participation in golf with supportive coaching and community building.",
      imageUrl: "https://images.unsplash.com/photo-1571158096385-a56767c1f57c?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZHJpdmluZyUyMHJhbmdlfGVufDB8fDB8fHww",
      features: ["Women-only sessions", "Beginner-friendly approach", "Networking events", "Professional development"]
    },
    {
      title: "Beginner to Pro Pathway",
      description: "Structured progression from complete beginner to professional levels with clear milestones and achievements.",
      imageUrl: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      features: ["Step-by-step curriculum", "Regular assessments", "Tournament participation", "Career guidance"]
    }
  ];
  */

  const coaches = [
    {
      name: "Rajiv Sharma",
      role: "Head Professional",
      experience: "15+ years PGA certified",
      specialty: "Swing Mechanics & Tournament Strategy"
    },
    {
      name: "Priya Mehta",
      role: "Performance Coach",
      experience: "8 years LPGA experience",
      specialty: "Short Game & Mental Training"
    },
    {
      name: "Arjun Patel",
      role: "Youth Development Director",
      experience: "10 years junior coaching",
      specialty: "Junior Golf & Talent Identification"
    }
  ];

  const facilities = [
    { icon: "🏌️", title: "Indoor Simulators", description: "Trackman & Foresight simulators for year-round training" },
    { icon: "🎯", title: "Practice Range", description: "200-yard driving range with multiple target greens" },
    { icon: "⛳", title: "Putting Greens", description: "Tournament-quality putting and chipping areas" },
    { icon: "💪", title: "Fitness Center", description: "Golf-specific strength and conditioning equipment" },
    { icon: "📊", title: "Video Analysis", description: "High-speed cameras for swing analysis" },
    { icon: "👨‍👩‍👧", title: "Family Lounge", description: "Comfortable viewing and waiting areas" }
  ];

  return (
    <>
      {/* Hero Section - Standardized with other pages */}
      <section className="academy-hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-pattern"></div>

        <Container className="position-relative z-3 h-100">
          <Row className="h-100 align-items-center justify-content-center">
            <Col xs={12} lg={10} xl={8} className="text-center text-white">
              <h1 className="hero-title mb-4">Golf Academy</h1>
              <p className="hero-subtitle mb-5">
                Nurturing raw talent and producing world-class golfers through systematic coaching
              </p>
              <div className="hero-cta d-flex flex-column flex-sm-row justify-content-center gap-3">
                {/* <a href="#coaches" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                  Book Assessment
                </a> */}
                <a href="#coaches" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                  Meet Our Coaches
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Academy Philosophy and Four Pillars sections removed */}

      {/* Programs Section - commented out */}
      {/* Programs for Every Golfer section removed */}

      {/* Facilities Section */}
      <section className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">World-Class Facilities</h2>
              <p className="section-subtitle">
                State-of-the-art training equipment and facilities for optimal development
              </p>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center">
            {facilities.map((facility, index) => (
              <Col xs={6} sm={4} lg={2} className="text-center mb-4" key={index}>
                <div className="facility-card p-3">
                  <div className="facility-icon mb-3">
                    {facility.icon}
                  </div>
                  <h4 className="h6 mb-2 facility-title">{facility.title}</h4>
                  <p className="facility-desc small mb-0">{facility.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Coaches Section */}
      <section id="coaches" className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col xs={12} className="text-center">
              <h2 className="section-title mb-3">Meet Our Coaches</h2>
              <p className="section-subtitle">
                Our team of certified professionals brings decades of experience and a passion for developing talent.
              </p>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center">
            {coaches.map((coach, index) => (
              <Col xs={12} md={6} lg={4} key={index}>
                <div className="coach-card card-modern h-100 p-3 p-md-4 text-center">
                  <div className="coach-avatar mx-auto mb-3 mb-md-4">
                    <span className="coach-icon">👨‍🏫</span>
                  </div>
                  <h3 className="h5 mb-2">{coach.name}</h3>
                  <p className="text-muted mb-2">{coach.role}</p>
                  <p className="small text-muted mb-3">{coach.experience}</p>
                  <p className="small text-gold mb-0">
                    {coach.specialty}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="section-padding">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} lg={8} className="text-center">
              <div className="newsletter-card">
                <div className="newsletter-icon mb-4">
                  🏌️
                </div>
                <h3 className="h2 mb-3 text-white">Start Your Golf Journey Today</h3>
                <p className="newsletter-text mb-4">
                  Book your complimentary assessment session and discover the perfect program
                  to help you achieve your golfing goals.
                </p>
                <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                  <a href="/contact" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                    Book Free Assessment
                  </a>
                  <a href="#coaches" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                    Meet Our Coaches
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CSS Styles */}
      <style jsx>{`
        /* Hero Section - Standardized with other pages */
        .academy-hero-section {
          height: 70vh;
          min-height: 600px;
          background: linear-gradient(rgba(31, 61, 43, 0.6), rgba(31, 61, 43, 0.75)), 
                     url('https://media.istockphoto.com/id/511665695/photo/young-coach-helping-golfer-on-beautiful-golf-course.jpg?s=612x612&w=0&k=20&c=f4QvO8JTT6MwpbRqnFIn7wY2xc6wDIi2RzZFpJ60W2g=') center/cover no-repeat;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding-top: 80px;
        }
        
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, rgba(31, 61, 43, 0.5) 0%, rgba(31, 61, 43, 0.7) 100%);
          z-index: 1;
        }
        
        .hero-pattern {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(circle at center, rgba(181, 154, 90, 0.1) 0%, transparent 70%);
          animation: pulse 4s ease-in-out infinite;
          z-index: 1;
        }
        
        .hero-title {
          font-size: clamp(2rem, 5vw, 3.5rem);
          color: #B59A5A;
          font-weight: 600;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          position: relative;
          z-index: 2;
          line-height: 1.2;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }
        
        .hero-subtitle {
          font-size: clamp(1rem, 2.5vw, 1.5rem);
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.95);
          text-shadow: 0 1px 3px rgba(0,0,0,0.3);
          position: relative;
          z-index: 2;
          margin-bottom: 2.5rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 400;
        }
        
        .hero-cta {
          position: relative;
          z-index: 2;
        }
        
        /* Button Styles */
        .btn-gold-filled {
          background-color: #B59A5A;
          color: #1F3D2B;
          border: none;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          white-space: nowrap;
        }
        
        .btn-gold-filled:hover {
          background-color: #d4b56e;
          color: #1F3D2B;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        
        .btn-gold {
          background-color: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(5px);
          color: #B59A5A;
          border: 2px solid #B59A5A;
          font-weight: 600;
          transition: all 0.3s ease;
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 1rem;
          white-space: nowrap;
        }
        
        .btn-gold:hover {
          background-color: rgba(181, 154, 90, 0.2);
          color: #d4b56e;
          border-color: #d4b56e;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15);
        }
        
        /* Section Styles */
        .section-padding {
          padding: clamp(3rem, 6vw, 5rem) 0;
        }
        
        .section-title {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          color: #1F3D2B;
          font-weight: 600;
          margin-bottom: 1rem;
          line-height: 1.2;
          font-family: 'Playfair Display', serif;
        }
        
        .section-subtitle {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          font-weight: 400;
        }
        
        /* Content Wrapper */
        .content-wrapper p {
          font-size: clamp(1rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          color: #666;
          margin-bottom: 1.5rem;
        }
        
        /* Philosophy Highlights */
        .philosophy-highlights {
          display: flex;
          flex-wrap: wrap;
          gap: clamp(1rem, 2vw, 1.5rem);
        }
        
        .highlight-item {
          text-align: center;
          padding: 1rem;
          flex: 1;
          min-width: 120px;
        }
        
        .highlight-item h3 {
          color: #B59A5A;
          font-size: clamp(1.5rem, 3vw, 2rem);
          font-weight: 600;
          margin-bottom: 0.25rem;
        }
        
        /* Philosophy Image */
        .philosophy-img {
          height: clamp(250px, 40vw, 400px);
          background: url('/images/golf-academy1.jpg') center/cover no-repeat;
          width: 100%;
          border-radius: 12px;
          overflow: hidden;
        }
        
        /* Pillar Cards */
        .pillar-card {
          padding: clamp(1.5rem, 3vw, 2rem);
          text-align: center;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
        }
        
        .pillar-card:hover {
          transform: translateY(-5px);
        }
        
        .pillar-icon {
          width: clamp(50px, 8vw, 60px);
          height: clamp(50px, 8vw, 60px);
          background-color: #B59A5A;
          color: white;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
          font-weight: 600;
          margin: 0 auto 1rem;
        }
        
        .pillar-card h3 {
          color: #1F3D2B;
          font-size: clamp(1rem, 1.8vw, 1.25rem);
          font-weight: 600;
        }
        
        .pillar-card p {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.5;
        }
        
        /* Program Cards */
        .program-card {
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
        }
        
        .program-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        }
        
        .program-img {
          height: clamp(200px, 30vw, 280px);
          width: 100%;
          background-size: cover;
          background-position: center;
          position: relative;
        }
        
        .program-img-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: clamp(1rem, 2vw, 1.5rem);
          background: linear-gradient(transparent, rgba(0,0,0,0.7));
        }
        
        .program-img-overlay h3 {
          font-size: clamp(1.25rem, 2vw, 1.5rem);
          font-weight: 600;
          font-family: 'Playfair Display', serif;
        }
        
        .program-content {
          flex: 1;
        }
        
        .program-content p {
          color: #666;
          font-size: clamp(0.95rem, 1.5vw, 1.05rem);
          line-height: 1.6;
        }
        
        .program-features {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .program-features li {
          margin-bottom: 0.75rem;
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        .feature-check {
          color: #B59A5A;
          font-weight: 600;
        }
        
        /* Facility Cards */
        .facility-card {
          transition: transform 0.3s ease;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          height: 100%;
        }
        
        .facility-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
        }
        
        .facility-icon {
          width: clamp(50px, 8vw, 60px);
          height: clamp(50px, 8vw, 60px);
          background-color: #f0f7f3;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.25rem, 2vw, 1.5rem);
          margin: 0 auto 1rem;
        }
        
        .facility-title {
          color: #1F3D2B;
          font-weight: 600;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        .facility-desc {
          color: #666;
          line-height: 1.4;
        }
        
        /* Coach Cards */
        .coach-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
          text-align: center;
        }
        
        .coach-card:hover {
          transform: translateY(-5px);
        }
        
        .coach-avatar {
          width: clamp(80px, 10vw, 100px);
          height: clamp(80px, 10vw, 100px);
          background-color: #f0f7f3;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .coach-icon {
          font-size: clamp(1.75rem, 3vw, 2rem);
        }
        
        .coach-card h3 {
          color: #1F3D2B;
          font-weight: 600;
          font-size: clamp(1rem, 1.8vw, 1.25rem);
          font-family: 'Playfair Display', serif;
        }
        
        .coach-card p {
          color: #666;
          font-size: clamp(0.9rem, 1.5vw, 1rem);
          line-height: 1.4;
        }
        
        /* Newsletter Card */
        .newsletter-card {
          background: linear-gradient(135deg, #1F3D2B 0%, #2a4d3b 100%);
          color: white;
          padding: clamp(2rem, 4vw, 3rem);
          border-radius: 15px;
          width: 100%;
        }
        
        .newsletter-icon {
          width: clamp(60px, 10vw, 80px);
          height: clamp(60px, 10vw, 80px);
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(1.5rem, 3vw, 2rem);
          margin: 0 auto 1.5rem;
        }
        
        .newsletter-text {
          opacity: 0.9;
          font-size: clamp(0.9rem, 1.5vw, 1.1rem);
          line-height: 1.6;
          margin-bottom: 2rem;
          font-weight: 400;
        }
        
        /* Background Colors */
        .bg-soft-sage {
          background-color: #f0f7f3;
        }
        
        /* Text Colors */
        .text-gold {
          color: #B59A5A;
        }
        
        .text-green {
          color: #1F3D2B;
        }
        
        .text-muted {
          color: #666;
        }
        
        /* Stats */
        .stat-number {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          color: #B59A5A;
          font-weight: 600;
          margin-bottom: 0.5rem;
          font-family: 'Playfair Display', serif;
        }
        
        .stat-label {
          color: #666;
          font-size: clamp(0.8rem, 1.5vw, 0.9rem);
          margin-bottom: 0;
          font-weight: 400;
        }
        
        /* Animations */
        @keyframes pulse {
          0%, 100% {
            opacity: 0.1;
          }
          50% {
            opacity: 0.2;
          }
        }
        
        /* Responsive Button Sizes */
        .btn-lg {
          padding: clamp(10px, 2vw, 12px) clamp(20px, 3vw, 32px);
          font-size: clamp(0.9rem, 1.5vw, 1rem);
        }
        
        /* Responsive Grid Gaps */
        .g-4 {
          --bs-gutter-x: clamp(1rem, 2vw, 1.5rem);
          --bs-gutter-y: clamp(1rem, 2vw, 1.5rem);
        }
        
        /* ================= MOBILE RESPONSIVE FIXES ================= */
        
        /* Extra Small Devices - Mobile Phones */
        @media (max-width: 576px) {
          .academy-hero-section {
            height: 65vh;
            min-height: 500px;
            padding-top: 100px;
          }
          
          .hero-title {
            margin-bottom: 1rem;
            font-size: 2.2rem;
          }
          
          .hero-subtitle {
            margin-bottom: 2rem;
            font-size: 1.1rem;
          }
          
          .hero-cta {
            flex-direction: column;
            gap: 1rem;
            margin-top: 20px;
          }
          
          .hero-cta .btn {
            width: 100%;
            padding: 14px 20px;
            font-size: 1rem;
          }
          
          .philosophy-img {
            height: 250px;
            margin-bottom: 1.5rem;
          }
          
          .highlight-item {
            min-width: 100px;
            padding: 0.75rem;
          }
          
          .program-img {
            height: 220px;
          }
          
          .facility-card {
            padding: 1rem;
          }
          
          .coach-avatar {
            width: 70px;
            height: 70px;
          }
          
          .coach-icon {
            font-size: 1.5rem;
          }
          
          .btn-lg {
            padding: 14px 20px;
          }
        }
        
        /* Small Devices - Larger Mobile Phones */
        @media (min-width: 577px) and (max-width: 768px) {
          .academy-hero-section {
            height: 70vh;
            min-height: 550px;
            padding-top: 90px;
          }
          
          .hero-title {
            font-size: 2.8rem;
          }
          
          .hero-subtitle {
            font-size: 1.3rem;
          }
          
          .hero-cta {
            margin-top: 10px;
          }
          
          .philosophy-img {
            height: 300px;
          }
          
          .program-img {
            height: 250px;
          }
        }
        
        /* Medium Devices - Tablets */
        @media (min-width: 769px) and (max-width: 992px) {
          .academy-hero-section {
            height: 75vh;
            min-height: 600px;
            padding-top: 80px;
          }
          
          .philosophy-img {
            height: 350px;
          }
          
          .program-img {
            height: 280px;
          }
        }
        
        /* Large Devices - Desktops */
        @media (min-width: 993px) and (max-width: 1199px) {
          .academy-hero-section {
            height: 80vh;
            min-height: 650px;
            padding-top: 60px;
          }
          
          .philosophy-img {
            height: 400px;
          }
        }
        
        /* Very Large Screens */
        @media (min-width: 1200px) {
          .academy-hero-section {
            height: 85vh;
            min-height: 700px;
            padding-top: 40px;
          }
        }
        
        /* Landscape Orientation on Mobile */
        @media (max-height: 600px) and (orientation: landscape) {
          .academy-hero-section {
            height: 100vh;
            min-height: 400px;
            padding-top: 80px;
          }
          
          .hero-title {
            font-size: 2rem;
            margin-bottom: 0.5rem;
          }
          
          .hero-subtitle {
            font-size: 1rem;
            margin-bottom: 1.5rem;
          }
          
          .philosophy-img {
            height: 200px;
          }
          
          .program-img {
            height: 180px;
          }
        }
        
        /* Accessibility: Focus states */
        button:focus,
        input:focus,
        a:focus {
          outline: 2px solid #B59A5A;
          outline-offset: 2px;
        }
        
        /* Print styles */
        @media print {
          .hero-cta,
          .newsletter-card {
            display: none !important;
          }
          
          .academy-hero-section {
            padding-top: 0;
            height: auto;
            min-height: auto;
          }
        }
      `}</style>
    </>
  );
};

export default Academy;